export enum MistralModels {
  MISTRAL = "mistral",
  MISTRAL_NEMO = "mistral-nemo",
  MISTRAL_LARGE = "mistral-large",
}

export const MistralModelsEnabled = [MistralModels.MISTRAL]
